<template>
  <h2 v-if="title" class="confirmation-title">{{ title }}</h2>
  <h2 v-if="retryTitle">
    <span class="confirmation-title1 text-danger">{{ retryTitle }}</span>
  </h2>
  <span v-if="subtitle">{{ subtitle }}</span>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "ConfirmationTitle",
  computed: {
    title() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;
      
      if (!retryOrderId) {
        return this.$t("messages.thanksForYourOrder");
      }
      return null;
    },
    retryTitle() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;
      
      if (retryOrderId) {
        return this.$t("messages.retryCrossell1");
      }
      return null;
    },
    subtitle() {
      const queryStringData = Object.fromEntries(
        new URL(window.location).searchParams,
      );
      const retryOrderId = queryStringData.retry;
      
      if (retryOrderId) {
        return this.$t("messages.retryCrossell2");
      } else {
        return this.$t("messages.confirmationEmailSent");
      }
    }
  },
  methods: {},
};
</script>
